import type { StatutIntervention } from '../api/interventions';

/**
 * Couleurs et libellés d'un statut, en un seul endroit.
 *
 * Classes du registre (`.spill` + tonalité) : même pastille et mêmes couleurs
 * que l'application principale, mode sombre compris. « Annulée » n'est pas une
 * alerte : tonalité neutre, le rouge restant réservé aux problèmes.
 */
const STYLES: Record<StatutIntervention, { libelle: string; ton: string }> = {
  planifiee: { libelle: 'Planifiée', ton: 'spill-info' },
  'en-cours': { libelle: 'En cours', ton: 'spill-action' },
  terminee: { libelle: 'Terminée', ton: 'spill-ok' },
  annulee: { libelle: 'Annulée', ton: 'spill-unknown' },
};

export function BadgeStatut({ statut }: { readonly statut: StatutIntervention }) {
  const style = STYLES[statut];
  return <span className={`spill ${style.ton}`}>{style.libelle}</span>;
}
